import { AiInsightCardModel } from 'src/app/shared/domain/ai-insights.model';

/** Local preview cards. Completion rate stands in for click tracking, which this product does not have. */
export function recommendationFixtures(): AiInsightCardModel[] {
  return [
    {
      id: 'rec-fill',
      title: 'Yield floor · Placement',
      statusLabel: 'Awaiting review',
      statusPill: 'status-pill--blue',
      badgeLabel: 'Medium confidence',
      badgePill: 'status-pill--orange',
      sourceLabel: 'DXK',
      dispositionLabel: 'Advisory',
      dispositionPill: 'status-pill--gray',
      observedLabel: 'Observed floor',
      observedValue: 'USD 4.20',
      suggestion: 'USD 4.20 → 4.83 (+15%)',
      rationale: 'Those placements are clearing below the network floor while the rest of the inventory is stable.',
      supportingMetrics: [
        { label: 'Requests', value: '1.2M' },
        { label: 'Fill rate', value: '41%' },
        { label: 'Floor', value: 'USD 4.20' },
      ],
      dataWindow: '14 Oct – 21 Oct UTC',
      ruleVersion: 'Rule set: yield-rules-v1',
      targetHref: null,
      targetLabel: 'Placement',
    },
    {
      id: 'rec-completion',
      title: 'Creative rotation · Creative',
      statusLabel: 'Awaiting review',
      statusPill: 'status-pill--blue',
      badgeLabel: 'Low confidence',
      badgePill: 'status-pill--info',
      sourceLabel: 'DXK',
      dispositionLabel: 'Advisory',
      dispositionPill: 'status-pill--gray',
      observedLabel: 'Observed',
      observedValue: '62%',
      suggestion: 'Rotate the two creatives whose completion rate fell over 21 days.',
      rationale: 'Completion rate on those creatives has fallen each of the last three weeks.',
      supportingMetrics: [
        { label: 'Completion rate', value: '62%' },
        { label: 'Days live', value: '21' },
        { label: 'Creatives', value: '2' },
      ],
      dataWindow: '1 Oct – 21 Oct UTC',
      ruleVersion: 'Rule set: creative-rules-v1',
      targetHref: null,
      targetLabel: 'Creative',
    },
    {
      id: 'rec-bid',
      title: 'Bid · Line item',
      statusLabel: 'Approved',
      statusPill: 'status-pill--green',
      badgeLabel: 'High confidence',
      badgePill: 'status-pill--green',
      sourceLabel: 'DXK',
      dispositionLabel: 'Needs approval',
      dispositionPill: 'status-pill--blue',
      observedLabel: 'Observed CPM',
      observedValue: 'USD 8.00',
      suggestion: 'USD 8.00 → 8.40 (+5%)',
      rationale: 'Win rate and margin have both stayed inside the band set for this line item.',
      supportingMetrics: [
        { label: 'Win rate', value: '62%' },
        { label: 'Margin', value: '18%' },
      ],
      dataWindow: '14 Oct – 21 Oct UTC',
      ruleVersion: 'Rule set: bid-rules-v1',
      targetHref: null,
      targetLabel: 'Line item',
    },
  ];
}

export function anomalyFixtures(): AiInsightCardModel[] {
  return [
    {
      id: 'anomaly-requests',
      title: 'Traffic · Publisher',
      statusLabel: 'Open',
      statusPill: 'status-pill--orange',
      badgeLabel: 'High',
      badgePill: 'status-pill--red',
      sourceLabel: null,
      dispositionLabel: null,
      dispositionPill: null,
      observedLabel: 'Requests',
      observedValue: '4.8M (expected 1.7M–2.1M)',
      suggestion: 'The increase is concentrated in a single publisher and does not match the rest of the network.',
      rationale: 'The increase is concentrated in a single publisher and does not match the rest of the network.',
      supportingMetrics: [{ label: 'Deviation', value: '180%' }],
      dataWindow: 'Detected 22 Oct UTC',
      ruleVersion: 'Rule set: anomaly-rules-v1',
      targetHref: null,
      targetLabel: 'Publisher',
    },
    {
      id: 'anomaly-revenue',
      title: 'Revenue · Demand connection',
      statusLabel: 'Open',
      statusPill: 'status-pill--orange',
      badgeLabel: 'Medium',
      badgePill: 'status-pill--orange',
      sourceLabel: null,
      dispositionLabel: null,
      dispositionPill: null,
      observedLabel: 'Revenue',
      observedValue: '12400 (expected 16000–19000)',
      suggestion: 'Win rate held steady until that demand partner dropped out of the auction.',
      rationale: 'Win rate held steady until that demand partner dropped out of the auction.',
      supportingMetrics: [{ label: 'Deviation', value: '-31%' }],
      dataWindow: 'Detected 22 Oct UTC',
      ruleVersion: 'Rule set: anomaly-rules-v1',
      targetHref: null,
      targetLabel: 'Demand connection',
    },
  ];
}
